<template>
  <div :class="$style.overlayModal">
    <div :class="$style.overlayContent">
      <div :class="$style.overlayHeader">
        <span :class="$style.overlayText" v-html="t('imageGallery.tenantPlus.title')" />
        <TenantPlusBadge :class="$style.badge" />
      </div>
      <HgButton theme="secondary" @click="onMoreImagesClick">{{
        t('imageGallery.tenantPlus.button')
      }}</HgButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { HgButton } from '@smg-real-estate/domus';

import TenantPlusBadge from '@/components/TenantPlus/Badge/TenantPlusBadge.vue';
import { EventLabel, InteractionEvent, InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';
import { useI18n } from 'vue-i18n';

defineOptions({
  name: 'TenantPlusGalleryModal',
});

const { t } = useI18n();

const emit = defineEmits<{
  moreImagesClick: [];
}>();

const trackMoreImagesClick = (): void => {
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: InteractionGoal.VIEW_BLUR_IMAGE,
    h_event_label_008: EventLabel.VIEW_BLURRY_IMAGE_PDP,
  });
};

const onMoreImagesClick = (): void => {
  trackMoreImagesClick();
  emit('moreImagesClick');
};
</script>

<style module lang="scss">
@import '@/assets/variables';

.overlayModal {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlayContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: $space-100;
  background: $color-white;
  border-radius: $border-radius-l;
}

.overlayHeader {
  display: flex;
  gap: $space-25;
  align-items: center;
  margin-bottom: $space-100;
}

.badge {
  align-items: center;
  padding: 0 $space-25;
  margin: 0;
}

.overlayText {
  text-wrap: nowrap;
}
</style>
